<template>
  <div class="report-wrap">
    <textarea class="text-report" v-model="adviceText" placeholder="请您描述意见或建议"></textarea>
    <div class="input-group">
      <mt-field placeholder="请输入姓名" :disableClear="true" v-model="userName"></mt-field>
      <mt-field placeholder="请输入手机或邮箱" type="email" :disableClear="true" v-model="contactInfo"></mt-field>
    </div>
    <button class="report-btn" @click="sendAdvice()">提交</button>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      userName: '',
      contactInfo: '',
      adviceText: ''
    }
  },
  methods: {
    sendAdvice () {
      const regFigure = /^\d+$/
      const regTel = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/
      const regEmail = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      if (!this.adviceText) {
        Toast({
          message: '请输入意见或建议',
          duration: 2500
        })
        return false
      }
      if (!this.userName) {
        Toast({
          message: '请输入姓名',
          duration: 2500
        })
        return false
      }
      if (!this.contactInfo) {
        Toast({
          message: '请输入手机或邮箱',
          duration: 2500
        })
        return false
      }
      if (regFigure.test(this.contactInfo)) {
        if (!regTel.test(this.contactInfo)) {
          Toast({
            message: '请输入正确的手机号',
            duration: 2500
          })
          return false
        }
      } else {
        if (!regEmail.test(this.contactInfo)) {
          Toast({
            message: '请输入正确的邮箱',
            duration: 2500
          })
          return false
        }
      }
      this.$http({
        url: '/data/getAdvice',
        method: 'POST',
        params: {
          content: this.adviceText,
          name: this.userName,
          phoneOrEmail: this.contactInfo
        }
      }).then((response) => {
        console.log (response)
        if (response.body.result) {
          Toast({
            message: '提交成功',
            duration: 2500
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .report-wrap {
    width: 100%;
    padding: 34px 30px 0;
  }
  .text-report {
    width: 100%;
    height: 324px;
    padding: 20px 25px;
    font-size: 28px;
    color: #131313;
    letter-spacing: 1.56px;
    background: #FFFFFF;
    border: none;
    resize: none;
    outline: none;
    border-radius: 4px;
  }
  .report-btn {
    display: block;
    width: 640px;
    height: 90px;
    margin: 50px auto 0;
    font-size: 36px;
    color: #FFFFFF;
    text-align: center;
    line-height: 90px;
    letter-spacing: 2px;
    background: #0CBB8D;
    border-radius: 8px;
  }
  .input-group {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/getAdvice.vue